import { render, staticRenderFns } from "./carrier-delete-warning-dialog.vue?vue&type=template&id=cf54ae16&scoped=true&lang=pug"
import script from "./carrier-delete-warning-dialog.vue?vue&type=script&lang=ts"
export * from "./carrier-delete-warning-dialog.vue?vue&type=script&lang=ts"
import style0 from "./carrier-delete-warning-dialog.vue?vue&type=style&index=0&id=cf54ae16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf54ae16",
  null
  
)

export default component.exports